import React from 'react';
import { Box } from 'theme-ui';

import Carousel from '../Carousel';

const RenderSectionForSideNav = ({ sideNavSliderItems }) => {
  return (
    <Box sx={parentCarouselStyles.base}>
      {sideNavSliderItems.map((item) => {
        if (item.carousel.length > 0) {
          return item.carousel.map((val) => (
            <Box id={item.title} key={Math.random().toString(36).substring(7)} sx={parentCarouselStyles.wrap}>
              <Carousel
                bilateralCarousel={val?._rawBilateralCarousel}
                carouselStyle={val?.carouselStyle}
                title={val?.title}
                bgColor={val?.bgColor}
                bilateralTextBlock={val?._rawBilateralTextBlock}
                isList
              />
            </Box>
          ));
        }
      })}
    </Box>
  );
};

const parentCarouselStyles = {
  base: {
    pb: [2, null, 6],
  },
};

export default RenderSectionForSideNav;
